<app-menu-bar></app-menu-bar>

<div class="page-wrapper">
  <div class="page-body">
    <div class="container-xl">

      <router-outlet></router-outlet>

    </div>
  </div>
</div>
